<div
  class="fixed top-0 inset-x-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-200/80 transition-all"
>
  <div class="container mx-auto">
    <div class="flex items-center justify-between px-4 py-3">
      <div class="flex items-center gap-3 cursor-pointer group" routerLink="/">
        <img
          src="./helageek.png"
          class="h-8 md:h-10 object-contain group-hover:scale-105 transition-transform"
          alt="Hela Geek Logo"
        />
      </div>

      <div class="flex items-center gap-6">
        <div class="relative inline-block">
          <fa-icon
            routerLink="/cart"
            routerLinkActive="text-[var(--primary)]"
            [icon]="faShoppingBag"
            class="cursor-pointer text-2xl text-gray-800 hover:text-[var(--primary)] transition"
          ></fa-icon>
          <span
            class="absolute -top-2 -right-2 bg-[var(--primary)] text-white text-xs font-black px-1.5 py-0.5 rounded-full min-w-[20px] text-center animate-pulse"
          >
            {{ cartItem }}
          </span>
        </div>

        @if (authService.isAuthenticated) {
          <button
            (click)="logout()"
            class="px-5 py-2 cursor-pointer flex items-center gap-2 border-2 border-[var(--primary)] text-[var(--primary)] font-bold text-sm md:text-base rounded-xl hover:bg-[var(--primary)] hover:text-white transition"
          >
            Logout
          </button>
        } @else {
          <button
            routerLink="/sign-in"
            class="px-6 py-2 cursor-pointer flex items-center gap-2 bg-[var(--primary)] text-white font-bold text-sm md:text-base rounded-xl hover:bg-gray-900 transition"
          >
            Sign-In
          </button>
        }
      </div>
    </div>
  </div>
</div>
